"use client";

import { useTranslations } from "next-intl";

export function SkipLink() {
    const t = useTranslations();
    return (
        <a
            href="#main-content"
            className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:start-2 focus:z-[9999] focus:bg-blue-600 focus:text-white focus:px-4 focus:py-2 focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-300"
        >
            {t("aria-skip-to-main")}
        </a>
    );
}
